var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.99997 0.187495C7.10194 0.186972 7.20301 0.206578 7.29739 0.245188C7.39177 0.283798 7.47761 0.340652 7.54997 0.412496C7.69729 0.560132 7.78003 0.76018 7.78003 0.968745C7.78003 1.17731 7.69729 1.37736 7.54997 1.525L2.09997 6.99999L7.56247 12.475C7.69866 12.6283 7.77388 12.8262 7.77388 13.0312C7.77388 13.2363 7.69866 13.4342 7.56247 13.5875C7.41046 13.7263 7.21206 13.8032 7.00622 13.8032C6.80039 13.8032 6.60198 13.7263 6.44997 13.5875L0.199973 7.33749C0.134089 7.26595 0.097517 7.17225 0.097517 7.075C0.097517 6.97774 0.134089 6.88404 0.199973 6.8125L6.44997 0.462497C6.51804 0.381559 6.60194 0.315408 6.69653 0.268114C6.79112 0.22082 6.89438 0.193383 6.99997 0.187495Z"}));
}

Arrow.defaultProps = {"viewBox":"0 0 8 14"};

module.exports = Arrow;

Arrow.default = Arrow;
